import React from 'react'
import search from '../assets/images/search.svg';
export default function SearchBox() {
    function handle(value) {
        console.log("inside handle = ", value)
    }
    return (
        <>
            <div className='vehicle-header-util'>
                <form action="https://www.google.com/" target="_blank" role="search" className="vehicle-header-search-form">
                    <input type="submit" value="" onClick={() => handle("dd")} className="vehicle-header-search-submit" />
                    <input type="search" name="q" className="vehicle-header-search-text" placeholder="Search..." autoComplete="off" />
                </form>
            </div>
            <style jsx="true">
                {`
                    /* SearchBox */
                    .vehicle-header-util input{
                        display: flex;
                        align-items: center;
                    }
                    .vehicle-header-search-form{
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                    }
                    /* Expandable search box */
                    /* Note: don't change 0.8s in transition. */
                    /* --------------------- */
                    input.vehicle-header-search-text {
                        color: #222;
                        position:relative;
                        z-index:5;
                        transition: z-index 0.8s, width 0.5s, background 0.3s ease, border 0.3s;
                        height: 35px;
                        width: 0;
                        margin: 0;
                        padding: 5px 35px 5px 5px;
                        box-sizing: border-box;
                        font-size: 16px;
                        font-size: 1rem;
                        cursor: pointer;
                        border-radius: 0.5rem;
                        border: 1px solid transparent;
                        background: url(${search}) no-repeat right 5px center transparent;
                        background-size: 20px;
                    }
                    input.vehicle-header-search-text:focus {
                        z-index:3; 
                        width: 100%;
                        box-shadow: 0px 0px 7px rgba(0, 0, 39, 0.15);
                        border-radius: 0.5rem;
                        background-color: #FFFFFF;
                        outline: none;
                        cursor: auto;
                        padding-left: 10px;
                    }
                    input.vehicle-header-search-submit {
                        position: absolute;
                        z-index: 4;
                        width: 35px;
                        height: 35px;
                        margin: 0;
                        border: 0;
                        outline: 0;
                        border-radius: 30px;
                        cursor: pointer; 
                        background: none;
                    }
                    input.vehicle-header-search-text::-webkit-search-cancel-button {
                        cursor:pointer;
                    }
            `}
            </style>
        </>
    )
}
